import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { Card } from 'components/Card';
import LoadingDots from 'components/LoadingDots';
import Message from 'components/Message';

import ReviewsStatisticsHeader from './ReviewsStatisticsHeaderContainer';
import './ReviewsStatisticsEmpty.scss';

const messages = defineMessages({
  empty: {
    id: 'reviews-statistics.empty',
    defaultMessage: 'No ratings statistics recorded yet',
  },
  emptyWithFilters: {
    id: 'reviews-statistics.empty-with-filters',
    defaultMessage: 'Ratings statistics for specified filters do not exist',
  },
});

const ReviewsStatisticsEmpty = ({ isLoading, hasActiveFilters }) => {
  const messageComponent = !hasActiveFilters ? (
    <Message message={messages.empty} />
  ) : (
    <Message message={messages.emptyWithFilters} />
  );

  return (
    <Card flush>
      <div className="reviews-statistics-empty">
        <ReviewsStatisticsHeader />
        <div className="reviews-statistics-empty__container">{isLoading ? <LoadingDots /> : messageComponent}</div>
      </div>
    </Card>
  );
};

ReviewsStatisticsEmpty.propTypes = {
  isLoading: PropTypes.bool,
  hasActiveFilters: PropTypes.bool,
};

export default ReviewsStatisticsEmpty;
